// Profile data extracted from resume
// Rakesh Kumar Tripathi - Cyber Security & IT Infrastructure Specialist
// Last updated: December 2024

export const personalInfo = {
  name: "Rakesh Kumar Tripathi",
  firstName: "Rakesh",
  lastName: "Kumar Tripathi",
  title: "Head of IT Services",
  headline: "Cyber Security & IT Infrastructure Specialist | Server Installation & Handling | ERPNext & Enterprise Systems | 25+ Years of Experience",
  tagline: "25+ Years of Excellence in Cyber Security & IT Infrastructure",
  email: "technovb@gmail.com",
  phone: "+91-9720979797",
  location: "Meerut, Uttar Pradesh, India",
  companyLocation: "Dwarka, New Delhi",
  website: "https://rakeshtripathi.com",
  linkedin: "https://www.linkedin.com/in/rakesh-kumar-tripathi",
  eportfolio: "https://eportfolio.mygreatlearning.com/rakesh-kumar-tripathi2",
  github: "https://github.com/technovb",
  profileImage: "/images/profile.jpg",
  resumeLink: "/resume.pdf",
};

export const summary = {
  short: "Seasoned IT professional with 25+ years of experience in server installation, handling, and cyber security, complemented by strong expertise in programming, ERP systems, and enterprise computing. Lead Auditor ISO 27001:2022 certified from Exemplar Global. Currently serving as Head of IT Services at Turacoz Healthcare Solutions and Director Systems at FIT Group of Institutions.",

  full: `Seasoned IT professional with 25+ years of experience in server installation, handling, and cyber security, complemented by strong expertise in programming, ERP systems, and enterprise computing. Lead Auditor ISO 27001:2022 certified from Exemplar Global. Also certified as a Microsoft Certified Professional (VB 5.0) and holder of STC Certification in High Performance & Enterprise Computing (IIT Kharagpur). Also, a part of many teachers' trainings in NITTTR, Chandigarh.

Since 2014, serving as Head of IT Services at Turacoz Healthcare Solutions Pvt. Ltd., where I specialize in server management, ERPNext customizations, system maintenance, and security initiatives. Skilled in Python, Blockchain, and enterprise IT systems (AS400, COBOL, JCL).

Recently transitioned focus fully into Cyber Security, completing advanced training from Great Lakes, AICTE, and industry experts. Completed Lead Auditor ISO 27001:2022 training from Royal Impact Certification Limited (Nov-Dec 2025). Currently working with Audit Team for SOC 2 Type 2 compliance.

Recognized as trustworthy, versatile, and proactive, with proven ability to strengthen IT infrastructure and safeguard digital assets.`,

  highlights: [
    "Lead Auditor ISO 27001:2022 certified from Exemplar Global (2025)",
    "25+ years of experience in server installation & cyber security",
    "Head of IT Services at Turacoz Healthcare Solutions and Director Systems at FIT Group of Institutions",
    "PG Program in Cyber Security from Great Lakes (2022-2023)",
    "Microsoft Certified Professional (Visual Basic 5.0)",
    "IIT Kharagpur certified in High Performance & Enterprise Computing",
    "Expert in ERPNext Development & Customization",
    "Skilled in Python, Blockchain & Data Analytics",
    "SOC 2 Type 2 compliance experience",
    "Zero Trust network architecture implementation",
    "AWS, Azure & Utho server management expertise",
  ],
};

// Core Competencies from resume
export const linkedinSkills = [
  "ISO 27001:2022 Lead Auditor",
  "Cyber Security",
  "Server Installation & Maintenance",
  "ERPNext Development",
  "Python & Blockchain",
  "IT Infrastructure",
  "ISMS Auditing",
  "VAPT Support",
  "Data Analytics",
  "Training & Mentorship",
  "System Administration",
];

export const experience = [
  {
    id: 1,
    title: "Head of IT Services",
    company: "Turacoz Healthcare Solutions Pvt. Ltd.",
    companyDescription: "Healthcare communications company working with global pharmaceutical clients",
    location: "New Delhi, India",
    startDate: "2014",
    endDate: "Present",
    duration: "10+ years",
    current: true,
    description: "Lead IT infrastructure & cyber security for a healthcare communications company. Responsible for server installations, ERPNext solutions, automated reports, and security initiatives.",
    responsibilities: [
      "Server installations, upgrades, patch management, and vulnerability assessment (VAPT) support",
      "Managing AWS, Azure, and Utho server environments",
      "Implementing Cloudflare-based security measures",
      "Administering multiple websites on a single VM via CloudPanel",
      "Deployed Zero Trust network architecture using Tailscale",
      "Customizing ERPNext to suit organization's needs",
      "Installation support, backup and restoration assistance",
      "Performing system analysis and Python-based automation scripts for reporting and analytics",
      "Managing system migrations from older to newer versions",
      "Installing OpenClinica, Biomed, LLAMA, Moodle, and BigBlueButton in Ubuntu environments",
      "Conducting Cyber Security Awareness and Compliance Trainings",
      "Working with Audit Team for SOC 2 Type 2",
    ],
    technologies: ["AWS", "Azure", "Utho", "Cloudflare", "CloudPanel", "Tailscale", "ERPNext", "Python", "Ubuntu", "OpenClinica", "Moodle", "BigBlueButton"],
    achievements: [
      "Successfully implemented Zero Trust network architecture",
      "Managed multiple cloud environments (AWS, Azure, Utho)",
      "Led SOC 2 Type 2 compliance initiatives",
      "Deployed comprehensive security measures with Cloudflare",
      "Implemented various healthcare and e-learning platforms",
    ],
  },
  {
    id: 2,
    title: "Director Systems",
    company: "FIT Group of Institutions",
    location: "Meerut, India",
    startDate: "2021",
    endDate: "Present",
    current: true,
    description: "Managed IT infrastructure, implemented secure server environments, ERP systems, and mentored students.",
    responsibilities: [
      "IT infrastructure management",
      "Implementing secure server environments",
      "ERP system implementation",
      "Student mentorship and guidance",
    ],
    technologies: ["Linux", "Windows Server", "ERP Systems", "Networking"],
    achievements: [
      "Established robust IT infrastructure for educational institution",
      "Mentored numerous students in technology careers",
    ],
  },
  {
    id: 3,
    title: "System Manager",
    company: "FIT Group of Institutions",
    location: "Meerut, India",
    startDate: "2009",
    endDate: "2021",
    duration: "12 years",
    current: false,
    description: "Managed IT infrastructure and systems for the educational institution.",
    responsibilities: [
      "System management and administration",
      "Network infrastructure maintenance",
      "IT support for academic departments",
      "Technology implementation for education",
    ],
    technologies: ["Linux", "Windows", "Networking", "Database Management"],
    achievements: [
      "Maintained stable IT operations for over a decade",
      "Upgraded institution's technology infrastructure",
    ],
  },
  {
    id: 4,
    title: "Assistant Professor",
    company: "FIT Group of Institutions",
    location: "Meerut, India",
    startDate: "2003",
    endDate: "2009",
    duration: "6 years",
    current: false,
    description: "Taught computer science and programming courses including C, Data Structures, Computer Networks, Operating Systems, C++, Java, Visual Basic, C#, ASP.Net, PHP, and Client-Server technologies.",
    responsibilities: [
      "Teaching programming languages: C, C++, Java, Python, Visual Basic, C#",
      "Conducting courses on Data Structures and Algorithms",
      "Teaching Computer Networks and Operating Systems",
      "Web development training: ASP.NET, PHP, Client-Server",
      "Developing comprehensive course curriculum and study materials",
      "Mentoring students on projects and career guidance",
    ],
    technologies: ["C", "C++", "Java", "Python", "Visual Basic", "C#", "ASP.NET", "PHP", "Data Structures", "Computer Networks", "Operating Systems"],
    achievements: [
      "Developed comprehensive course materials for multiple programming subjects",
      "Mentored numerous students who built successful IT careers",
    ],
  },
  {
    id: 5,
    title: "Faculty",
    company: "STG",
    location: "Moradabad, India",
    startDate: "2001",
    endDate: "2003",
    duration: "2 years",
    current: false,
    description: "Trained students in programming, computer networks, and enterprise systems.",
    responsibilities: [
      "Teaching programming fundamentals",
      "Computer networking courses",
      "Enterprise systems training",
    ],
    technologies: ["C", "C++", "Networking", "Enterprise Systems"],
    achievements: [],
  },
  {
    id: 6,
    title: "Faculty",
    company: "SSI",
    location: "Meerut, India",
    startDate: "2000",
    endDate: "2001",
    duration: "1 year",
    current: false,
    description: "Faculty member teaching computer science subjects.",
    responsibilities: [
      "Teaching computer fundamentals",
      "Programming instruction",
    ],
    technologies: ["C", "C++", "Computer Fundamentals"],
    achievements: [],
  },
  {
    id: 7,
    title: "Faculty",
    company: "STG",
    location: "Modinagar, India",
    startDate: "1999",
    endDate: "2000",
    duration: "1 year",
    current: false,
    description: "Faculty member teaching computer science subjects.",
    responsibilities: [
      "Teaching programming",
      "Computer applications training",
    ],
    technologies: ["C", "Programming Fundamentals"],
    achievements: [],
  },
  {
    id: 8,
    title: "Faculty",
    company: "CMC Ltd",
    location: "Meerut, India",
    startDate: "1998",
    endDate: "1999",
    duration: "1 year",
    current: false,
    description: "Faculty member at CMC Ltd, a premier IT training and services company.",
    responsibilities: [
      "IT training delivery",
      "Programming instruction",
    ],
    technologies: ["C", "Programming", "IT Fundamentals"],
    achievements: [],
  },
];

export const education = [
  {
    id: 1,
    degree: "PG Program in Cyber Security",
    institution: "Great Lakes Institute of Management",
    location: "India",
    year: "2022-2023",
    type: "Postgraduate Program",
    description: "Advanced postgraduate program in Cyber Security covering modern security practices, threat analysis, and enterprise security frameworks.",
    highlights: [
      "Cyber Security Fundamentals",
      "Network Security",
      "Threat Analysis",
      "Security Frameworks",
      "Compliance & Governance",
    ],
  },
  {
    id: 2,
    degree: "Business Analytics & Text Mining Using Python",
    institution: "NPTEL",
    location: "Online",
    year: "2022",
    type: "Professional Certification",
    description: "Comprehensive course on business analytics and text mining using Python programming.",
    highlights: [
      "Business Analytics",
      "Text Mining",
      "Python Programming",
      "Data Analysis",
    ],
  },
  {
    id: 3,
    degree: "ERPNext Developer Training",
    institution: "Solufy",
    location: "India",
    year: "2020",
    type: "Professional Certification",
    description: "Specialized training in ERPNext development and customization using Frappe Framework.",
    highlights: [
      "ERPNext Development",
      "Frappe Framework",
      "Custom Module Development",
      "API Integration",
    ],
  },
  {
    id: 4,
    degree: "Blockchain Technology & Applications",
    institution: "NPTEL",
    location: "Online",
    year: "2020",
    type: "Professional Certification",
    description: "Comprehensive course on blockchain technology, smart contracts, and decentralized applications.",
    highlights: [
      "Blockchain Fundamentals",
      "Smart Contracts",
      "Decentralized Applications",
      "Cryptocurrency",
    ],
  },
  {
    id: 5,
    degree: "STC - High Performance & Enterprise Computing",
    institution: "Indian Institute of Technology (IIT) Kharagpur",
    location: "Kharagpur, West Bengal, India",
    year: "2010",
    type: "Professional Certification",
    description: "Short Term Course certification covering enterprise computing technologies and high-performance systems from India's premier technical institute.",
    highlights: [
      "High Performance Computing",
      "Enterprise Computing",
      "AS400 Systems",
      "COBOL Programming",
      "JCL (Job Control Language)",
      "Mainframe Technologies",
    ],
  },
  {
    id: 6,
    degree: "M.Sc. Computer Science",
    institution: "Vinayaka Missions University",
    location: "India",
    year: "2008-2010",
    type: "Master's Degree",
    description: "Master of Science in Computer Science with focus on advanced computing concepts and software development.",
    highlights: [
      "Advanced Programming",
      "Software Engineering",
      "Database Systems",
      "Computer Networks",
    ],
  },
  {
    id: 7,
    degree: "B.Sc. Mathematics, Statistics, Economics",
    institution: "University",
    location: "India",
    year: "1997-2000",
    type: "Bachelor's Degree",
    description: "Bachelor of Science with Mathematics, Statistics, and Economics providing strong analytical foundation.",
    highlights: [
      "Mathematics",
      "Statistics",
      "Economics",
      "Analytical Skills",
    ],
  },
  {
    id: 8,
    degree: "Microsoft Certified Professional (MCP)",
    institution: "Microsoft Corporation",
    location: "Global Certification",
    year: "1998",
    type: "Professional Certification",
    description: "Microsoft Certified Professional certification in Visual Basic 5.0, demonstrating proficiency in Microsoft development technologies.",
    highlights: [
      "Visual Basic 5.0",
      "Windows Application Development",
      "Microsoft Development Tools",
      "Database Connectivity",
    ],
  },
];

export const skills = {
  // Core competencies from resume
  primary: [
    { name: "Server Installation & Maintenance", level: 95, source: "Linux/Windows" },
    { name: "Cyber Security", level: 92, source: "Network & System Hardening, VAPT Support" },
    { name: "ERPNext Development", level: 92, source: "Development & Customization" },
    { name: "Python & Blockchain", level: 88, source: "Data Analytics" },
    { name: "IT Infrastructure", level: 95, source: "System Administration" },
    { name: "Training & Mentorship", level: 95, source: "Academic Experience" },
  ],

  technical: [
    { name: "Linux Administration", level: 95, category: "Infrastructure" },
    { name: "Windows Server", level: 90, category: "Infrastructure" },
    { name: "Cyber Security", level: 92, category: "Security" },
    { name: "VAPT Support", level: 88, category: "Security" },
    { name: "ERPNext/Frappe", level: 92, category: "Enterprise Solutions" },
    { name: "Python", level: 90, category: "Programming" },
    { name: "Blockchain", level: 85, category: "Programming" },
    { name: "Data Analytics", level: 88, category: "Analytics" },
    { name: "AWS", level: 85, category: "Cloud Computing" },
    { name: "Azure", level: 85, category: "Cloud Computing" },
    { name: "C Programming", level: 92, category: "Programming" },
    { name: "C++", level: 90, category: "Programming" },
    { name: "Java", level: 88, category: "Programming" },
    { name: ".NET", level: 85, category: "Programming" },
    { name: "Visual Basic", level: 90, category: "Programming" },
    { name: "PHP", level: 85, category: "Programming" },
    { name: "COBOL", level: 78, category: "Enterprise Solutions" },
    { name: "JCL", level: 78, category: "Enterprise Solutions" },
    { name: "Cloudflare", level: 88, category: "Security" },
    { name: "CloudPanel", level: 85, category: "Infrastructure" },
    { name: "Tailscale/Zero Trust", level: 85, category: "Security" },
    { name: "Moodle", level: 90, category: "Enterprise Solutions" },
    { name: "BigBlueButton", level: 85, category: "Enterprise Solutions" },
    { name: "OpenClinica", level: 80, category: "Enterprise Solutions" },
  ],

  soft: [
    { name: "Intelligent", level: 95 },
    { name: "Confident", level: 92 },
    { name: "Creative", level: 90 },
    { name: "Optimistic", level: 88 },
    { name: "Trustworthy", level: 95 },
    { name: "Versatile", level: 92 },
    { name: "Knowledgeable", level: 95 },
    { name: "Friendly", level: 90 },
  ],

  tools: [
    "AWS",
    "Azure",
    "Utho",
    "Cloudflare",
    "CloudPanel",
    "Tailscale",
    "ERPNext",
    "Frappe Framework",
    "Moodle LMS",
    "BigBlueButton",
    "OpenClinica",
    "LLAMA",
    "Biomed",
    "Linux (Ubuntu/CentOS)",
    "Windows Server",
    "Python IDEs",
    "Visual Studio",
    "MySQL/MariaDB",
    "Git/GitHub",
    "Docker",
    "VS Code",
    "Microsoft Office Suite",
    "Security Tools",
  ],

  programmingLanguages: [
    "C",
    "C++",
    "Java",
    ".NET",
    "Visual Basic",
    "PHP",
    "Python",
    "COBOL",
    "JCL",
  ],

  categories: [
    {
      name: "Server Installation & Maintenance",
      skills: ["Linux", "Windows", "Server Administration", "Patch Management"],
      description: "Complete server lifecycle management",
    },
    {
      name: "Cyber Security",
      skills: ["Network Hardening", "System Hardening", "VAPT Support", "SOC 2 Type 2"],
      description: "Comprehensive security expertise",
    },
    {
      name: "ERPNext Development",
      skills: ["ERPNext", "Frappe Framework", "Custom Modules", "System Migration"],
      description: "Enterprise resource planning solutions",
    },
    {
      name: "Programming",
      skills: ["Python", "Blockchain", "C", "C++", "Java", ".NET", "Visual Basic", "PHP", "COBOL", "JCL"],
      description: "Multi-language programming expertise",
    },
    {
      name: "Cloud Computing",
      skills: ["AWS", "Azure", "Utho", "Cloudflare", "CloudPanel"],
      description: "Multi-cloud infrastructure management",
    },
    {
      name: "IT Infrastructure",
      skills: ["System Administration", "Network Management", "Zero Trust Architecture", "Tailscale"],
      description: "Enterprise IT infrastructure",
    },
  ],
};

export const certifications = [
  {
    id: 0,
    name: "Lead Auditor ISO 27001:2022",
    specialization: "Information Security Management System (ISMS)",
    issuer: "Exemplar Global",
    trainingProvider: "Royal Impact Certification Limited",
    year: "2025",
    credentialId: "EG-LA-27001",
    description: "Certified Lead Auditor for ISO 27001:2022 Information Security Management System. Completed 5-day intensive weekend batch training (22 Nov - 13 Dec 2025) with examination on 14 Dec 2025. Qualified to lead ISMS audits and assessments for organizations.",
    skills: ["ISO 27001:2022", "ISMS Auditing", "Information Security", "Risk Assessment", "Compliance Auditing", "Lead Auditor"],
    logo: "/images/certs/exemplar-global.png",
    featured: true,
  },
  {
    id: 1,
    name: "PG Program in Cyber Security",
    specialization: "Cyber Security",
    issuer: "Great Lakes Institute of Management",
    year: "2022-2023",
    credentialId: "GL-CS",
    description: "Advanced postgraduate program in Cyber Security covering modern security practices and enterprise frameworks.",
    skills: ["Cyber Security", "Network Security", "Threat Analysis", "Compliance"],
    logo: "/images/certs/greatlakes.png",
  },
  {
    id: 2,
    name: "Business Analytics & Text Mining Using Python",
    specialization: "Data Analytics",
    issuer: "NPTEL",
    year: "2022",
    credentialId: "NPTEL-BA",
    description: "Comprehensive course on business analytics and text mining using Python.",
    skills: ["Python", "Business Analytics", "Text Mining", "Data Analysis"],
    logo: "/images/certs/nptel.png",
  },
  {
    id: 3,
    name: "ERPNext Developer Training",
    specialization: "ERPNext Development",
    issuer: "Solufy",
    year: "2020",
    credentialId: "SOL-ERP",
    description: "Specialized training in ERPNext development and customization.",
    skills: ["ERPNext", "Frappe Framework", "Custom Development"],
    logo: "/images/certs/solufy.png",
  },
  {
    id: 4,
    name: "Blockchain Technology & Applications",
    specialization: "Blockchain",
    issuer: "NPTEL",
    year: "2020",
    credentialId: "NPTEL-BC",
    description: "Comprehensive course on blockchain technology and applications.",
    skills: ["Blockchain", "Smart Contracts", "Decentralized Applications"],
    logo: "/images/certs/nptel.png",
  },
  {
    id: 5,
    name: "STC in High Performance & Enterprise Computing",
    specialization: "Enterprise Computing",
    issuer: "Indian Institute of Technology (IIT) Kharagpur",
    year: "2010",
    credentialId: "IIT-HPC",
    description: "Short Term Course certification covering high performance computing and enterprise systems.",
    skills: ["High Performance Computing", "AS400", "COBOL", "JCL", "Enterprise Computing"],
    logo: "/images/certs/iit.png",
  },
  {
    id: 6,
    name: "Microsoft Certified Professional (MCP)",
    specialization: "Visual Basic 5.0",
    issuer: "Microsoft Corporation",
    year: "1998",
    credentialId: "MCP-VB5",
    description: "Official Microsoft certification in Visual Basic 5.0 development.",
    skills: ["Visual Basic 5.0", "Windows Application Development", "Microsoft Technologies"],
    logo: "/images/certs/microsoft.png",
  },
];

export const projects = [
  {
    id: 1,
    title: "Server Management & Cloud Infrastructure",
    description: "Responsible for server installations, upgrades, patch management, and vulnerability assessment (VAPT) support at Turacoz. Successfully managed AWS, Azure, and Utho server environments.",
    technologies: ["AWS", "Azure", "Utho", "Linux", "VAPT", "Patch Management"],
    category: "Cloud",
    featured: true,
    linkedToExperience: "Head of IT Services at Turacoz",
    challenges: [
      "Managing multi-cloud environments",
      "Ensuring high availability",
      "Security compliance requirements",
      "Cost optimization",
    ],
    outcomes: [
      "Stable multi-cloud infrastructure",
      "Enhanced security posture",
      "Optimized cloud costs",
      "Improved system reliability",
    ],
  },
  {
    id: 2,
    title: "Zero Trust Network Architecture",
    description: "Deployed Zero Trust network architecture using Tailscale and implemented Cloudflare-based security measures. Administered multiple websites on a single VM via CloudPanel.",
    technologies: ["Tailscale", "Cloudflare", "CloudPanel", "Zero Trust"],
    category: "Security",
    featured: true,
    linkedToExperience: "Head of IT Services at Turacoz",
    challenges: [
      "Implementing Zero Trust model",
      "Securing remote access",
      "Managing multiple websites securely",
      "Balancing security with usability",
    ],
    outcomes: [
      "Secure Zero Trust architecture",
      "Protected remote access",
      "Centralized website management",
      "Enhanced security posture",
    ],
  },
  {
    id: 3,
    title: "ERPNext Customization & Implementation",
    description: "Customizing ERPNext to suit Turacoz's needs, providing installation support, backup and restoration assistance, performing system analysis, and managing system migrations.",
    technologies: ["ERPNext", "Frappe Framework", "Python", "MySQL", "JavaScript"],
    category: "Enterprise",
    featured: true,
    linkedToExperience: "Head of IT Services at Turacoz",
    challenges: [
      "Complex healthcare industry requirements",
      "Custom module development",
      "System migrations",
      "Data integrity during migrations",
    ],
    outcomes: [
      "Customized ERP solution",
      "Streamlined operations",
      "Successful system migrations",
      "Improved data management",
    ],
  },
  {
    id: 4,
    title: "Healthcare Platform Installations",
    description: "Responsible for installing various healthcare and e-learning components including OpenClinica, Biomed, LLAMA, Moodle, and BigBlueButton in Ubuntu environments.",
    technologies: ["OpenClinica", "Biomed", "LLAMA", "Moodle", "BigBlueButton", "Ubuntu"],
    category: "E-Learning",
    featured: false,
    linkedToExperience: "Head of IT Services at Turacoz",
    challenges: [
      "Complex installation requirements",
      "Integration between platforms",
      "Healthcare compliance",
      "Performance optimization",
    ],
    outcomes: [
      "Functional e-learning platform",
      "Integrated healthcare tools",
      "Compliance with standards",
      "Efficient training delivery",
    ],
  },
  {
    id: 5,
    title: "Python Automation & Analytics",
    description: "Developed Python-based automation scripts for reporting and analytics to streamline business processes and enhance data-driven decision making.",
    technologies: ["Python", "Pandas", "Automation", "Data Analytics"],
    category: "Analytics",
    featured: false,
    linkedToExperience: "Head of IT Services at Turacoz",
    challenges: [
      "Identifying automation opportunities",
      "Data integration from multiple sources",
      "Creating actionable reports",
    ],
    outcomes: [
      "Automated reporting workflows",
      "Reduced manual data processing",
      "Improved data accuracy",
      "Better business insights",
    ],
  },
  {
    id: 6,
    title: "SOC 2 Type 2 Compliance",
    description: "Currently working with Audit Team for SOC 2 Type 2 compliance, implementing necessary security controls and documentation.",
    technologies: ["Security Controls", "Compliance Frameworks", "Audit Processes"],
    category: "Security",
    featured: false,
    linkedToExperience: "Head of IT Services at Turacoz",
    challenges: [
      "Understanding SOC 2 requirements",
      "Implementing security controls",
      "Documentation and evidence gathering",
      "Continuous monitoring",
    ],
    outcomes: [
      "Progress toward SOC 2 compliance",
      "Enhanced security controls",
      "Documented security processes",
      "Audit-ready documentation",
    ],
  },
  {
    id: 7,
    title: "Cyber Security Awareness Training",
    description: "Conducted Cyber Security Awareness and Compliance Trainings for organization staff to enhance security culture.",
    technologies: ["Security Training", "Compliance", "Awareness Programs"],
    category: "Security",
    featured: false,
    linkedToExperience: "Head of IT Services at Turacoz",
    challenges: [
      "Engaging diverse audience",
      "Keeping content relevant",
      "Measuring training effectiveness",
    ],
    outcomes: [
      "Security-aware workforce",
      "Reduced security incidents",
      "Improved compliance awareness",
      "Better security culture",
    ],
  },
];

// About Turacoz Healthcare Solutions (Company Information)
export const companyInfo = {
  name: "Turacoz Healthcare Solutions Pvt. Ltd.",
  description: "Healthcare communications company working with global pharmaceutical clients",
  services: [
    "Medical Communications",
    "Clinical Trials Services",
    "Scientific Publishing",
    "Medical Writing",
    "Regulatory Writing",
    "Healthcare IT Solutions",
  ],
  clients: "Global pharmaceutical companies",
  regions: ["Global"],
  locations: {
    india: "New Delhi, India",
  },
  established: "2014",
  website: "https://turacoz.com",
};

export const services = [
  {
    id: 1,
    title: "Server Installation & Maintenance",
    description: "Complete server lifecycle management including installation, configuration, patch management, and security hardening for Linux and Windows environments.",
    icon: "server",
    linkedToSkill: "Server Expert",
  },
  {
    id: 2,
    title: "Cyber Security Services",
    description: "Network and system hardening, VAPT support, security assessments, and implementation of Zero Trust architecture.",
    icon: "security",
    linkedToSkill: "Cyber Security Specialist",
  },
  {
    id: 3,
    title: "ERPNext Implementation",
    description: "End-to-end ERPNext implementation, customization, migration support, and ongoing maintenance services.",
    icon: "erp",
    linkedToSkill: "ERPNext Expert",
  },
  {
    id: 4,
    title: "Cloud Infrastructure",
    description: "AWS, Azure, and multi-cloud infrastructure setup, management, and optimization services.",
    icon: "cloud",
    linkedToSkill: "Cloud Expert",
  },
  {
    id: 5,
    title: "Python Development & Analytics",
    description: "Python-based automation, data analytics solutions, and custom application development.",
    icon: "code",
    linkedToSkill: "Python Expert",
  },
  {
    id: 6,
    title: "IT Training & Mentoring",
    description: "Comprehensive training programs in programming languages, cyber security, and IT infrastructure with 25+ years of teaching experience.",
    icon: "training",
    linkedToSkill: "Experienced Trainer",
  },
  {
    id: 7,
    title: "LMS Implementation",
    description: "Moodle and BigBlueButton setup, customization, and administration for e-learning initiatives.",
    icon: "learning",
    linkedToSkill: "LMS Expert",
  },
  {
    id: 8,
    title: "Compliance & Audit Support",
    description: "SOC 2 Type 2 compliance preparation, security controls implementation, and audit support services.",
    icon: "compliance",
    linkedToSkill: "Compliance Specialist",
  },
];

export const stats = [
  { label: "Years of Experience", value: "25+", description: "In IT & Security" },
  { label: "Programming Languages", value: "15+", description: "Taught & Practiced" },
  { label: "At Turacoz Since", value: "2014", description: "10+ Years" },
  { label: "Cloud Platforms", value: "3+", description: "AWS, Azure, Utho" },
];

export const industries = [
  { name: "Healthcare", description: "Medical Communications at Turacoz" },
  { name: "Education", description: "FIT Group of Institutions" },
  { name: "IT Training", description: "CMC Ltd, STG, SSI" },
];

export const values = [
  {
    title: "Trustworthy",
    description: "Recognized for reliability and integrity in handling sensitive IT infrastructure and security responsibilities.",
    icon: "trust",
  },
  {
    title: "Versatile",
    description: "Adaptable across technologies - from traditional programming to modern cloud and security solutions.",
    icon: "versatile",
  },
  {
    title: "Proactive",
    description: "Taking initiative in identifying and implementing solutions before problems arise.",
    icon: "proactive",
  },
  {
    title: "Knowledgeable",
    description: "Continuous learning from certifications at Great Lakes, NPTEL, and IIT Kharagpur.",
    icon: "knowledge",
  },
];

export const navigation = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about" },
  { name: "Experience", path: "/experience" },
  { name: "Skills", path: "/skills" },
  { name: "Projects", path: "/projects" },
  { name: "Education", path: "/education" },
  { name: "Blogs", path: "/blogs" },
  { name: "Contact", path: "/contact" },
];

export default {
  personalInfo,
  summary,
  linkedinSkills,
  experience,
  education,
  skills,
  certifications,
  projects,
  companyInfo,
  services,
  stats,
  industries,
  values,
  navigation,
};
